export interface EIP1193Provider {
  isStatus?: boolean;
  host?: string;
  path?: string;
  sendAsync?: (
    request: { method: string; params?: Array<unknown> },
    callback: (error: Error | null, response: unknown) => void
  ) => void;
  send?: (
    request: { method: string; params?: Array<unknown> },
    callback: (error: Error | null, response: unknown) => void
  ) => void;
  request: (request: { method: string; params?: Array<unknown> }) => Promise<unknown>;
}

export enum LocalStorageKey {
  jwt = 'jwt',
  refresh = 'refresh',
  eoaJwt = 'eoaJwt',
  lastConnectedWallet = 'lastConnectedWallet',
  currentWallet = 'currentWallet',
  loggedByEoa = 'loggedByEoa',
  user = 'user'
}
